import { component } from "picoapp";
import getProductJson from "../lib/getProductJson";
import { handleOptionTitle } from "./product-selection";

export default component(async (node) => {
  const [{ default: KeenSlider }] = await Promise.all([
    import("keen-slider"),
    import("keen-slider/keen-slider.min.css"),
  ]);

  const checkbox = node.querySelector('input[name="pdp-upsell-active"]');
  const sliderElement = node.querySelector("[data-keen-slider]");
  const selectId = node.dataset.id;
  const mainProductFormId = "id";

  const handlePrice = () => {
    const newPrice = checkbox.dataset.price;
    const newComparePrice = checkbox.dataset.comparePrice;

    if (newPrice) {
      const priceEvent = new CustomEvent("price:update", {
        detail: {
          price: newPrice,
          comparePrice: newComparePrice,
        },
      });
      window.dispatchEvent(priceEvent);
    } else {
      const mainVariantSelect = document.getElementById(mainProductFormId);
      const mainVariantOption =
        mainVariantSelect.options[mainVariantSelect.selectedIndex];
      const mainVariantPrice = mainVariantOption.dataset.price;
      const upsellVariantSelect = document.getElementById(selectId);
      const upsellVariantOption =
        upsellVariantSelect.options[upsellVariantSelect.selectedIndex];
      const upsellVariantPrice = upsellVariantOption.dataset.price;

      const priceEvent = new CustomEvent("price:update", {
        detial: {
          price: parseInt(mainVariantPrice) + parseInt(upsellVariantPrice),
          comparePrice: newComparePrice,
        },
      });
      window.dispatchEvent(priceEvent);
    }
  };
  const select = document.getElementById(selectId);
  const initialSlide = node.querySelector(
    `[data-variant-id="${select.value}"]`
  );
  const slider = new KeenSlider(sliderElement, {
    drag: false,
    initial: parseInt(initialSlide.dataset.index),
    created: (slider) => {
      slider.container.classList.remove("hide-init");
    },
  });

  const handleCarousel = (variant) => {
    const selectedSlide = slider.slides.find((slide) => {
      return parseInt(slide.dataset.variantId) === variant.id;
    });
    if (!selectedSlide) return;
    const index = selectedSlide.dataset.index;
    slider.moveToIdx(parseInt(index));
  };

  checkbox.addEventListener("change", async function (e) {
    const checked = e.target.checked;
    const product = await getProductJson();
    if (checked) {
      const selectInput = document.getElementById(selectId);
      const currentVariantId = selectInput.value;
      const upsellVariantSelectedEvent = new CustomEvent(
        `variant-selected:${selectId}`,
        {
          detail: {
            product: product.handle,
            variant: currentVariantId,
          },
        }
      );
      window.dispatchEvent(upsellVariantSelectedEvent);
    } else {
      const selectInput = document.getElementById(mainProductFormId);
      const currentVariantId = selectInput.value;
      const reselectVariantEvent = new CustomEvent(
        `variant-selected:${mainProductFormId}`,
        {
          detail: {
            product: product.handle,
            variant: currentVariantId,
          },
        }
      );
      window.dispatchEvent(reselectVariantEvent);
    }
  });

  window.addEventListener("variant-selected:pdp-upsell", async (event) => {
    const product = await getProductJson();
    const variant = product.variants.find(
      (v) => parseInt(v.id) === parseInt(event.detail.variant)
    );
    handleOptionTitle(variant, selectId);
    handleCarousel(variant);

    if (checkbox.checked) {
      handlePrice();
    }
  });
});
